import React from 'react'
import firebase from './../Firestore'
//import store from '../../store';

//import FormularioDatosCliente from './FormularioDatosCliente'

class DetallePedido extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.detalleProducto = this.detalleProducto.bind(this);
    this.state = {
      productosEnCarrito: []
     };
  }


componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.pedidoId !== prevProps.pedidoId) this.levantarDetallesPedido(this.props.pedidoId)
}




levantarDetallesPedido(pedidoId){
  let db = firebase.firestore()
  let currentComponent = this;
  db.collection("pedidoDetalle").where("pedidoId", "==", pedidoId)
      .get()
      .then(function(querySnapshot) {
      //  console.log("hace el setstate en carrito")

        currentComponent.setState(
          {
            productosEnCarrito: querySnapshot.docs.map(doc => {
              return {
                "id": doc.id,
                "pedidoId": doc.data().pedidoId,
                "productoId": doc.data().productoId,
                "tamano": doc.data().tamano,
                "cantidad": doc.data().cantidad,
                "esAdicional": doc.data().esAdicional,
                "confirmado": doc.data().confirmado
              }
            })
          }
        );

      })
      .catch(function(error) {
        //  console.log("Error getting documents: ", error);
      });
}


componentWillMount(){
  if(this.props.pedidoId) this.levantarDetallesPedido(this.props.pedidoId)
  //console.log("this.props.pedidoId en detallePedido", this.props.pedidoId)
}

componentWillUnmount(){
  //console.log("en carrito WillUnmount")
  this._isMounted = false;

}

detalleProducto(esAdicional, arr, value, propiedad1, propiedad2="") {

  if(esAdicional){
    if(propiedad1 === "nombreCategoria"){
      return "Adicional"
    }else{
      arr = this.props.adicionalDetalle;
    }
  }

  for (var i=0, iLen=arr.length; i<iLen; i++) {
    if(esAdicional){
      if (arr[i].id === value) return arr[i].data[propiedad1];
    } else if(propiedad1 === "nombreCategoria"){
      if (arr[i].id === value) return arr[i].nombre;
    }

    if(propiedad2 === ""){
      if(esAdicional){
        if (this.props.adicionalDetalle[i].id === value) return this.props.adicionalDetalle[i].propiedad1;
      }
      else if (arr[i].id === value){
          return arr[i].data[propiedad1];
      }
    }else{
      if (arr[i].id === value) return arr[i].data[propiedad1][propiedad2];
    }
  }
}


  render() {

    if(!this.props.cat) return ""

      var subTotal = [];
      var cantidad = [];
      //var granTotal;
      let Items = this.state.productosEnCarrito.map((todo, i) =>

        <tr id={todo.id} key={todo.id} >
          <td>
            <span className="h6 mr-1">{this.detalleProducto(todo.esAdicional, this.props.cat, this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "categoriaID" ), "nombreCategoria" )}</span>
            <span className="mr-1"><em>{todo.tamano}</em></span>
            <span>{this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "nombre" )}</span>
          </td>
          <td>{cantidad[i] = todo.cantidad}</td>
          <td>$ {subTotal[i] = cantidad[i] * this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "precio", todo.tamano )}</td>
        </tr>
      )


      return (
        <div>

        {this.state.productosEnCarrito.length > 0 &&
          <div>
          <table className="table table-sm">
            <thead>
              <tr>
                <th scope="col">Detalle del pedido</th>
                <th scope="col">Cant.</th>
                <th scope="col">SubTotal</th>
              </tr>
            </thead>
            <tbody>
              {Items}
              <tr>
                <td></td>
                <td></td>
                <td><strong>$ {subTotal.reduce((a, b) => a + b, 0)}</strong></td>
              </tr>

            </tbody>
          </table>

          </div>
        }
        </div>
      )
    }

  }

export default DetallePedido
